module.exports = __webpack_public_path__ + "img/sumo.58c86aa1.png";